import { OrderHelper } from "./OrderHelper"
import { I18N } from "./I18N"
import { RejectWaitingOrder } from "./RejectWaitingOrder"

export class AcceptOrder {
	constructor (target, order, store, completeTaskAction, taskBtn) {
		this._order = order
		this._store = store
		this._completeTaskAction = completeTaskAction
		this._taskBtn = taskBtn
		this._target = document.getElementById(target)
		this._target.setAttribute('hidden', '')
	}

	close = () => this.setVisible(false)

	setVisible = visible => {
		if (visible) {
			const printChecked = localStorage.getItem('printReceiptCb') !== 'false'
			this._target.innerHTML = `
				<div class="modalCanvas">
				<div id="acceptOrderModalShader" class="modalShader"></div>
				<div class="card modal">
					<button id="acceptOrderCloseBtn" class="closeBtn"><span class="material-icons">close</span></button>
					<div class="dlgTopSpacer"><h2 i18n>Preparation time</h2></div>
					<div class="btnGroup vertical">
						<div class="btnGroup">
							<button type="button" class="acceptBtn primary" time="5">5min</button>
							<button type="button" class="acceptBtn primary" time="10">10min</button>
							<button type="button" class="acceptBtn primary" time="15">15min</button>
							<button type="button" class="acceptBtn primary" time="20">20min</button>
							<button type="button" class="acceptBtn primary" time="30">30min</button>
							<button type="button" class="acceptBtn primary" time="45">45min</button>
							<button type="button" class="acceptBtn primary" time="60">1std</button>
							<button type="button" class="acceptBtn" time="-1">${I18N.translate('Reject')}</button>
						</div>
						<div class="labeled-input input-before">
							<span class="radioWrapper">
								<input type="checkbox" id="printReceiptCb" ${printChecked ? 'checked' : ''}>
							</span>
							<label for="printReceiptCb" i18n>Print receipt</label>
						</div>
					</div>
					<div class="card" style="width: fit-content;">
						${OrderHelper.getReceiptHtml(this._order, this._store, '58mm', '3.5mm')}
					</div>
				</div>
			`
			this._target.querySelector('#printReceiptCb').addEventListener('change', ev => localStorage.setItem('printReceiptCb', ev.currentTarget.checked))
			this._target.querySelector('#acceptOrderModalShader').addEventListener('click', () => this.close())
			this._target.querySelector('#acceptOrderCloseBtn').addEventListener('click', () => this.close())
			this._target.querySelectorAll('.acceptBtn').forEach(btn => btn.addEventListener('click', ev => {
				const time = Number(ev.currentTarget.getAttribute('time'))
				const printReceipt = this._target.querySelector('#printReceiptCb').checked
				if (time === -1) {
					// Ablehnung erfordert wie beim Abweisen einer wartenden Bestellung
					// (RejectWaitingOrder) einen Grund - der Kunde erhält ihn über denselben
					// Notification-Mechanismus.
					this.close()
					const rejectDialog = new RejectWaitingOrder('rejectOrder', this._completeTaskAction, this._taskBtn, { accepted: 'cancelled' }, printReceipt)
					rejectDialog.setVisible(true)
					return
				}
				const variables = { accepted: 'accepted', preparationMinutes: time }
				this._completeTaskAction(this._taskBtn, variables, printReceipt)
				this.close()
			}))
			I18N.translateElement(this._target)
			this._target.removeAttribute('hidden')
			window.scrollTo(0, 0)
		}
		else {
			this._target.innerHTML = ''
			this._target.setAttribute('hidden', '')
		}
	}
}